export interface ManualQuoteRequestDTO {
  existingQuoteId: string;
  leadVehicleId?: number;
  newValuation: number;
  contactId?: string;
}
